/* import __COLOCATED_TEMPLATE__ from './error-message.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();